import { render, staticRenderFns } from "./PageTitleComponent.vue?vue&type=template&id=7c937913&scoped=true&functional=true&"
import script from "./PageTitleComponent.vue?vue&type=script&lang=js&"
export * from "./PageTitleComponent.vue?vue&type=script&lang=js&"
import style0 from "./PageTitleComponent.vue?vue&type=style&index=0&id=7c937913&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7c937913",
  null
  
)

export default component.exports